<div class="h-full w-64 bg-white dark:bg-gray-900 text-gray-900 dark:text-white flex flex-col border-r border-gray-200 dark:border-gray-800">
    <div class="p-4 border-b border-gray-200 dark:border-gray-700">
      <button
        (click)="newSession.emit()"
        class="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors flex items-center justify-center gap-2 font-medium">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path></svg>
        New Chat
      </button>
    </div>
    <div class="flex-1 overflow-y-auto p-2 scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-700">
      <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-500 uppercase tracking-wide mb-2 px-2 mt-2">Recent Chats</h3>
      @for (session of sessions; track session.id) {
        <div class="relative group mb-1">
          <!-- Main Session Button -->
          <button
            (click)="onSessionSelected.emit(session)"
            [class.bg-gray-100]="session.id === currentId"
            [class.dark:bg-gray-800]="session.id === currentId"
            [class.text-gray-900]="session.id === currentId"
            [class.dark:text-white]="session.id === currentId"
            [class.text-gray-600]="session.id !== currentId"
            [class.dark:text-gray-400]="session.id !== currentId"
            class="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors text-sm text-left group">
            <!-- Message Icon -->
            <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
            </svg>
            <div class="flex-1 min-w-0">
               <div class="truncate font-medium">{{session.title}}</div>
               <div class="text-xs text-gray-500 dark:text-gray-500 mt-0.5">{{session.createdAt | date:'shortDate'}}</div>
            </div>
          </button>

          <!-- 3-Dot Menu Button -->
          <button
            (click)="onToggleMenu($event, session.id)"
            class="absolute right-2 top-3 p-1 rounded-md text-gray-500 opacity-0 group-hover:opacity-100 hover:text-gray-900 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-all"
            title="More options">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
            </svg>
          </button>

          <!-- Delete Dropdown Menu -->
          @if (openMenuId === session.id) {
            <div class="absolute z-20 right-0 top-10 w-32 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-md shadow-xl py-1 transform origin-top-right">
              <button
                (click)="onDeleteClick($event, session)"
                class="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-gray-700/50">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                Delete
              </button>
            </div>
          }
        </div>
      }

    </div>

    <div class="border-t border-gray-200 dark:border-gray-800 p-4">
      <app-sidebar-account></app-sidebar-account>
    </div>
</div>
